const bathroom = `Solicitud de reparación de baño
Hola,
Espero que estés bien.
Necesito contarte sobre el baño de mi departamento.
Los grifos gotean, algunos azulejos están rotos y hay moho, lo que dificulta su uso.
También está provocando mal olor en el apartamento.
¿Puede la empresa constructora arreglar el baño?
Es importante poner fin a estos problemas y mejorar el apartamento para todos.
Las obras pueden comenzar el 15 de noviembre y finalizar el 10 de diciembre.
Si necesita más información o quiere hablar sobre esto, puede llamarme al 555-555-5555 o enviarme un correo electrónico a example@email.com.
Gracias por escuchar.
Cuídate, `
export default bathroom;